import { timezonesEnum } from '../utils';
import { useFleet } from './useFleet';

export const useTimezone = (fleetTimezone?: string): string => {
  const fleetFromStore = useFleet();

  return fleetTimezone || fleetFromStore?.timezone || timezonesEnum.AMERICA_NEW_YORK;
};
